var uniqueIndex;

uniqueIndex = 0;

module.exports = function() {
  return String(uniqueIndex++);
};
